import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { RoleGuard } from '#core/components/auth/role.guard';
import { DASHBOARD_ROUTES } from '#modules/dashboard/routes/dashboard.routing';
import { feedbackFormsFeatureGuard } from '#modules/feedback-forms/guards/feedback-forms-feature.guard';
import { provideRestaurantFeedbackFormsScope } from '#modules/feedback-forms/models/feedback-forms-scope';
import { BOOSTERS_ROUTES } from '#shell/routing/logged-in/restaurants/boosters/boosters.routing';
import { INTERACTIONS_ROUTES } from '#shell/routing/logged-in/restaurants/interactions/interactions.routing';
import { REPUTATION_ROUTES } from '#shell/routing/logged-in/restaurants/reputation/reputation.routing';
import { RESOURCES_ROUTES } from '#shell/routing/logged-in/restaurants/resources/resources.routing';
import { provideRestaurantsScope } from '#shell/routing/logged-in/restaurants/restaurants.providers';
import { SEO_ROUTES } from '#shell/routing/logged-in/restaurants/seo/seo.routing';
import { SETTINGS_ROUTES } from '#shell/routing/logged-in/restaurants/settings/settings.routing';
import { SOCIAL_ROUTES } from '#shell/routing/logged-in/restaurants/social/social.routing';
import { STATISTICS_ROUTES } from '#shell/routing/logged-in/restaurants/statistics/statistics.routing';

export const RESTAURANTS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/restaurants-layout.component').then((m) => m.RestaurantsLayoutComponent),
        providers: [provideRestaurantsScope()],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard',
            },
            {
                path: 'dashboard',
                loadChildren: () => DASHBOARD_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.DASHBOARD },
            },
            {
                path: 'informations',
                redirectTo: 'seo/informations',
            },
            {
                path: 'seo',
                loadChildren: () => SEO_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.SEO },
            },
            {
                path: 'boosters',
                loadChildren: () => BOOSTERS_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.BOOSTERS },
            },
            {
                path: 'reputation',
                loadChildren: () => REPUTATION_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.E_REPUTATION },
            },
            {
                path: 'social',
                loadChildren: () => SOCIAL_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.SOCIAL_NETWORKS },
            },
            {
                path: 'interactions',
                loadChildren: () => INTERACTIONS_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.INTERACTIONS },
            },
            {
                path: 'statistics',
                loadChildren: () => STATISTICS_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.STATISTICS },
            },
            {
                path: 'resources',
                loadChildren: () => RESOURCES_ROUTES,
                data: { routePath: RoutePath.RESOURCES },
            },
            {
                path: 'settings',
                loadChildren: () => SETTINGS_ROUTES,
                canActivate: [RoleGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.SETTINGS },
            },
            {
                path: 'feedback-forms',
                providers: [provideRestaurantFeedbackFormsScope()],
                loadChildren: () => import('#modules/feedback-forms/routes/feedback-forms.routes').then((m) => m.FEEDBACK_FORMS_ROUTES),
                canActivate: [RoleGuard, feedbackFormsFeatureGuard],
                data: { roles: ['admin', 'malou-basic'], routePath: RoutePath.FEEDBACK_FORMS },
            },
        ],
    },
];
